/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import { getCustomStyles, reactSelectStyle } from "Config/Config";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";

//import options
import publishOptions from "data/Prod/PublishOptions.json";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData, putData, uploadMultipleFile } from "utils/Gateway";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

import SucessStorySuccessModal from "../Modal/SucessStorySuccessModal";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const AddUpdateSuccessStoryBody = () => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const breadcrumbTxt = [{ title: "Success Story" }];

  const params = useParams();
  const history = useHistory();

  // Extract 'type' parameter from URL query string
  const queryParams = new URLSearchParams(window.location.search);
  const companyIdParam = queryParams.get("companyid");

  const titleRef = useRef(null);
  const projectNameRef = useRef(null);
  const companyRef = useRef(null);

  const [companyInput, setCompanyInput] = useState("");
  const [companyList, setCompanyList] = useState([]);

  const [storyName, setStoryName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [companyValue, setCompanyValue] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [successStorySummary, setSuccessStorySummary] = useState("");
  const [successStoryDetails, setSuccessStoryDetails] = useState("");
  const [successStorySitutation, setSuccessStorySitutation] = useState("");
  const [successStoryObjectives, setSuccessStoryObjectives] = useState("");
  const [successStoryProcess, setSuccessStoryProcess] = useState("");
  const [successStoryResults, setsuccessStoryResults] = useState("");
  const [ownerComments, setOwnerComments] = useState("");
  const [successStoryUrl, setSuccessStoryUrl] = useState("");
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFileIds, setUploadedFileIds] = useState([]);
  const [publishValue, setPublishValue] = useState(null);
  const [publishStatus, setPublishStatus] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [formTouched, setFormTouched] = useState(false); // <-- Track if the form has been touched

  //function for validate form
  const validateForm = () => {
    const newErrors = {};

    if (!storyName.trim()) {
      newErrors.storyName = t(
        "Story title cannot be empty. Please provide a title."
      );
    }

    if (!projectName.trim()) {
      newErrors.projectName = t(
        "Project name cannot be empty. Please provide a project name."
      );
    }

    if (!companyValue) {
      newErrors.companyValue = t(
        "Company cannot be empty. Please select a company."
      );
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      if (newErrors.storyName && titleRef.current) {
        setTimeout(() => {
          titleRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          titleRef.current.setAttribute("tabindex", "-1");
          titleRef.current.focus();
        }, 100);
      } else if (newErrors.projectName && projectNameRef.current) {
        setTimeout(() => {
          projectNameRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          projectNameRef.current.setAttribute("tabindex", "-1");
          projectNameRef.current.focus();
        }, 100);
      } else if (newErrors.companyValue && companyRef.current) {
        setTimeout(() => {
          companyRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          // Focus the Select component's input
          const selectElement = companyRef.current.querySelector(
            ".react-select__control"
          );
          if (selectElement) {
            selectElement.focus();
          }
        }, 100);
      }
    }

    return Object.keys(newErrors).length === 0;
  };

  //function for get all company list
  const getAllCompanyList = async () => {
    try {
      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?token=${token}&filtername=${companyInput}`;

      console.log("url of company list------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response in company list------>", response);

      if (response.status) {
        setCompanyList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for company details for query params
  const getCompanyDetails = async () => {
    try {
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_COMPANY_DETAILS}/${companyIdParam}?token=${token}&modulefrom=backend`;
      const response = await getData(requestUrl);

      if (response.status) {
        const companyObj = {
          label: response.data.name,
          value: response.data._id,
        };

        companySelectionHandler(companyObj);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for select company
  const companySelectionHandler = (val) => {
    if (val) {
      setCompanyValue(val);
      setCompanyId(val.value);
    } else {
      setCompanyValue(null);
      setCompanyId(null);
    }
  };

  //function for image upload
  const fileUploadHandler = async (uploadedStoryFiles) => {
    try {
      setIsFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, uploadedStoryFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/

        setIsFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedFileIds.length == 0) {
          setUploadedFileIds(fileIds);
        } else {
          let fileArr = uploadedFileIds.concat(fileIds);
          setUploadedFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for delete file from upload stack
  const closeFileHandler = (index) => {
    const closedFile = [...uploadedFiles];
    const removedFileId = [...uploadedFileIds];

    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);

    setUploadedFiles(closedFile);
    setUploadedFileIds(removedFileId);
  };

  //function for select publish
  const publishSelectionHandler = (val) => {
    setPublishValue(val);
    setPublishStatus(val.value);
  };

  //close modal function
  const afterSuccessModalClose = () => {
    resetStoryHandler();
    if (companyIdParam) {
      history.push(`/admin/companies/successstories/${companyIdParam}`);
    } else {
      history.push("/admin/successstories/list");
    }
  };

  //function for reset
  const resetStoryHandler = () => {
    setStoryName("");
    setProjectName("");
    setCompanyValue(null);
    setCompanyId(null);
    setSuccessStorySummary("");
    setSuccessStoryDetails("");
    setSuccessStorySitutation("");
    setSuccessStoryObjectives("");
    setSuccessStoryProcess("");
    setsuccessStoryResults("");
    setSuccessStoryUrl("");
    setUploadedFiles([]);
    setUploadedFileIds([]);
    setPublishValue(null);
    setPublishStatus(null);
  };

  //function for get blog details
  const getSuccessStoryDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SUCCESS_STORY_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response story details---->", response);

      if (response.status) {
        setStoryName(response.data?.name);
        setProjectName(response.data.projectname);
        companySelectionHandler(response.data.companydata);
        setSuccessStorySummary(response.data?.summary);
        setSuccessStoryDetails(response.data?.description);
        setSuccessStorySitutation(response.data?.previoussituation);
        setSuccessStoryObjectives(response.data?.previousobjectives);
        setSuccessStoryProcess(response.data?.processdata);
        setsuccessStoryResults(response.data?.resultsdata);
        setOwnerComments(response.data?.ownertestimonial);
        setSuccessStoryUrl(response.data?.url);

        setUploadedFiles(
          response.data?.uploads.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );
        const fileIds = response.data?.uploads.map(({ _id, ...other }) => ({
          _id,
        }));
        setUploadedFileIds(fileIds);

        //assing publish
        if (response.data?.publish) {
          publishOptions.map((publishData) => {
            if (publishData.value == response.data.publish) {
              publishSelectionHandler(publishData);
            }
          });
        }
      } else {
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for create/update blog
  const saveStoryHandler = async () => {
    setFormTouched(true); // <-- Mark form as touched on save attempt
    if (!validateForm()) {
      setErrorMessage(
        t("Please correct the highlighted fields before saving.")
      );
      return;
    }
    try {
      setIsSaving(true);

      let storyData = {
        user: userInfo._id,
        name: storyName,
        companyid: companyId,
        projectname: projectName,
        summary: successStorySummary,
        description: successStoryDetails,
        previoussituation: successStorySitutation,
        previousobjectives: successStoryObjectives,
        processdata: successStoryProcess,
        resultsdata: successStoryResults,
        ownertestimonial: ownerComments,
        uploads: uploadedFileIds,
        publish: publishStatus,
        url: successStoryUrl,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_SUCCESS_STORY +
          `/${params.id}` +
          `?token=${token}`;

        response = await putData(requestUrl, storyData);
      } else {
        storyData.tags = [];
        requestUrl =
          requestUrl + url.API_ADD_NEW_SUCCESS_STORY + `?token=${token}`;

        response = await postData(requestUrl, storyData);
      }

      console.log("response in save story---->", response);

      if (response.status) {
        setIsSaving(false);
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSaveSuccessStoryModal")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (params.id) {
      getSuccessStoryDetails();
    }
  }, [params.id]);

  useEffect(() => {
    if (companyInput.length > 2) {
      getAllCompanyList();
    }
  }, [companyInput]);

  useEffect(() => {
    if (companyIdParam) {
      getCompanyDetails();
    }
  }, [companyIdParam]);

  return (
    <div id="content_wrapper">
      <section className="blog-wrapper bg-white pb-5">
        <div className="container-fluid px-lg-5">
          <BreadCrumb breadCrumbText={breadcrumbTxt} bottom={true} />
          {errorMessage && (
            <div className="alert alert-danger mt-3" role="alert">
              {errorMessage}
            </div>
          )}
          <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
            {/* ------ Story Information section start ------- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">{t("Story Information")}</h5>
              <div className="row">
                <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                  <label
                    htmlFor="title"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    Title <span className="text-danger">*</span>
                  </label>
                  <input
                    ref={titleRef}
                    type="text"
                    id="title"
                    className={`form-control fs-sm shadow-none ${
                      errors.storyName ? "is-invalid" : "border border-gray-300"
                    }`}
                    placeholder="Enter story title"
                    value={storyName}
                    onChange={(e) => {
                      setStoryName(e.target.value);
                      setErrorMessage("");
                      if (errors.storyName) {
                        setErrors((prev) => ({ ...prev, storyName: "" }));
                      }
                    }}
                    aria-describedby="storyNameFeedback"
                  />
                  {errors.storyName && (
                    <div id="storyNameFeedback" className="invalid-feedback">
                      {errors.storyName}
                    </div>
                  )}
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="projectName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    Project name <span className="text-danger">*</span>
                  </label>
                  <input
                    ref={projectNameRef}
                    type="text"
                    id="projectName"
                    className={`form-control fs-sm shadow-none ${
                      errors.projectName
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    placeholder="Enter project name"
                    value={projectName}
                    onChange={(e) => {
                      setProjectName(e.target.value);
                      setErrorMessage("");
                      if (errors.projectName) {
                        setErrors((prev) => ({ ...prev, projectName: "" }));
                      }
                    }}
                    aria-describedby="projectNameFeedback"
                  />
                  {errors.projectName && (
                    <div id="projectNameFeedback" className="invalid-feedback">
                      {errors.projectName}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* ------ Story Information section end ------- */}

            {/* ------ Company and URL selection section start ------- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">Company and URL</h5>
              <div className="row">
                <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                  <label
                    htmlFor="company"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    Company <span className="text-danger">*</span>
                  </label>
                  <div
                    ref={companyRef}
                    className={`${
                      formTouched && errors.companyValue
                        ? "is-invalid-select"
                        : ""
                    }`}
                    aria-describedby="companyValueFeedback"
                  >
                    <Select
                      isClearable
                      options={companyList}
                      value={companyValue}
                      onChange={(val) => {
                        companySelectionHandler(val);
                        setErrorMessage("");
                        if (errors.companyValue) {
                          setErrors((prev) => ({ ...prev, companyValue: "" }));
                        }
                      }}
                      onInputChange={(val) => setCompanyInput(val)}
                      styles={getCustomStyles(errors.companyValue)}
                      classNamePrefix="react-select"
                      placeholder="Select company"
                    />
                  </div>
                  {formTouched && errors.companyValue && (
                    <div
                      id="companyValueFeedback"
                      className="invalid-feedback d-block"
                    >
                      {errors.companyValue}
                    </div>
                  )}
                </div>
                <div className="col-lg-6">
                  <label
                    htmlFor="facebook"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    Url
                  </label>
                  <input
                    type="text"
                    id="facebook"
                    className="form-control fs-sm shadow-none border border-gray-300"
                    placeholder="Paste story URL (optional)"
                    value={successStoryUrl}
                    onChange={(e) => setSuccessStoryUrl(e.target.value)}
                  />
                </div>
              </div>
            </div>
            {/* ------ Company and URL selection section end ------- */}

            {/* ------ seo summary section start ------- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label htmlFor="seo" className="d-block fs-sm fw-semibold mb-2">
                Summary
              </label>
              <textarea
                name="details"
                id="details"
                cols="30"
                rows="5"
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder="Enter summary for SEO..."
                value={successStorySummary}
                onChange={(e) => {
                  setSuccessStorySummary(e.target.value);
                  setErrorMessage("");
                }}
              ></textarea>
            </div>
            {/* ------ seo summary section end ------- */}

            {/* ------ details section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Details"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={successStoryDetails}
                onChange={(newContent) => {
                  setSuccessStoryDetails(newContent);
                  setErrorMessage("");
                }}
                editorHeight={250}
              />
            </div>
            {/* ------ details section end ------ */}

            {/* ------ Previous Situation details section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Previous Situation"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={successStorySitutation}
                onChange={(newContent) => {
                  setSuccessStorySitutation(newContent);
                  setErrorMessage("");
                }}
                editorHeight={250}
              />
            </div>
            {/* ------ Previous Situation details section end ------ */}

            {/* ------ Previous Objectives details section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Objectives"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={successStoryObjectives}
                onChange={(newContent) => {
                  setSuccessStoryObjectives(newContent);
                  setErrorMessage("");
                }}
                editorHeight={250}
              />
            </div>
            {/* ------ Previous Objectives details section end ------ */}

            {/* ------ Process details section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Process"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={successStoryProcess}
                onChange={(newContent) => {
                  setSuccessStoryProcess(newContent);
                  setErrorMessage("");
                }}
                editorHeight={250}
              />
            </div>
            {/* ------ Process details section end ------ */}

            {/* ------ Results details section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Results"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={successStoryResults}
                onChange={(newContent) => {
                  setsuccessStoryResults(newContent);
                  setErrorMessage("");
                }}
                editorHeight={250}
              />
            </div>
            {/* ------ Results details section end ------ */}

            {/* ------ Owner comment section start ------ */}
            <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
              <JoditEditorField
                label="Company Owner Comments"
                labelClassName="d-block fs-sm fw-semibold mb-2"
                value={ownerComments}
                onChange={(newContent) => setOwnerComments(newContent)}
                editorHeight={250}
              />
            </div>
            {/* ------ Owner comment section end ------ */}

            {/* ------ attachment section start ------- */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <label
                htmlFor="attachments"
                className="d-block fs-sm fw-semibold mb-2"
              >
                Attachments
              </label>
              <FileUploadField
                label={t("Attachments")}
                accept="doc xls xlsx pdf"
                onUpload={fileUploadHandler}
                files={uploadedFiles}
                onRemove={closeFileHandler}
                loading={isFileUploading}
                multiple
                fileType="document"
                placeholder="Upload documents (doc, xls, xlsx, pdf)"
              />
            </div>
            {/* ------ attachment section end ------- */}

            {/* ------ Publish & Agreement section start ------ */}
            <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
              <h5 className="mb-3 fw-semibold">Publish & Agreement</h5>
              <div className="row align-items-center">
                <div className="col-lg-6 mb-3 mb-lg-0">
                  <label
                    htmlFor="categories"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    Publish
                  </label>
                  <Select
                    options={publishOptions}
                    value={publishValue}
                    onChange={(val) => publishSelectionHandler(val)}
                    styles={getCustomStyles(false)}
                    placeholder="Select publish status"
                  />
                </div>
                <div className="col-lg-6">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    Agreement
                  </label>
                  <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                    <input
                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                      type="checkbox"
                      id="flexCheckDefault"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      Agree with the <Link to="#">Legal Notice</Link> &{" "}
                      <Link to="#">Privacy Policy</Link>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/* ------ Publish & Agreement section end ------ */}

            {/* ------ save and cancel button section start ------ */}
            <div className="action d-flex flex-wrap justify-content-between gap-3">
              <Link
                onClick={resetStoryHandler}
                to="/admin/successstories/list"
                className="btn btn-outline-primary"
              >
                Cancel
              </Link>
              <button
                type="button"
                className="btn btn-primary"
                onClick={saveStoryHandler}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                disabled={isSaving ? true : false}
              >
                Save Now
                {isSaving && (
                  <div
                    className="mx-2 spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
            </div>
            {/* ------ save and cancel button section end ------ */}
          </div>
        </div>
      </section>

      {/* ------ success message modal ------ */}
      <SucessStorySuccessModal
        afterSuccessModalClose={afterSuccessModalClose}
      />
    </div>
  );
};

export default AddUpdateSuccessStoryBody;
